import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export default function AdminTopUp({ player, onDone }) {
  const [open, setOpen] = useState(false);
  const [amount, setAmount] = useState("");
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);
  const t = `admin-topup-${player.user_id}`;
  const send = async () => {
    const n = parseInt(amount, 10);
    if (!n || n < 1) return toast.error("Enter how many credits to add");
    if (!window.confirm(`Add ${n.toLocaleString()} credits to ${player.email}?`)) return;
    setBusy(true);
    try {
      await api.post("/admin/gift", { target: "one", email: player.email, amount: n, message: message.trim() || null, gift_id: crypto.randomUUID() });
      toast.success(`${n.toLocaleString()} credits added to ${player.email}`);
      setOpen(false); setAmount(""); setMessage(""); onDone();
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <>
      <button data-testid={`${t}-btn`} onClick={() => setOpen(true)} className="px-3 py-1 rounded-full border border-amber-500/50 text-amber-200 text-xs hover:bg-amber-500/10">TOP UP</button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-[#081820] border-slate-700" data-testid={`${t}-dialog`}>
          <DialogHeader>
            <DialogTitle className="font-display text-amber-100">Top up {player.wolf?.name || player.name}</DialogTitle>
            <DialogDescription>{player.email} · balance {player.credits.toLocaleString()} credits. They'll see a gift popup with your message.</DialogDescription>
          </DialogHeader>
          <Input data-testid={`${t}-amount`} type="number" min="1" value={amount} onChange={(e) => setAmount(e.target.value)} placeholder="Credits, e.g. 5000" className="bg-slate-950" />
          <Input data-testid={`${t}-message`} maxLength={200} value={message} onChange={(e) => setMessage(e.target.value)} placeholder="Message (optional), e.g. Thanks for joining the promo!" className="bg-slate-950" />
          <button data-testid={`${t}-send`} disabled={busy} onClick={send} className="ember-btn w-full py-3 rounded-full text-sm disabled:opacity-40">{busy ? "ADDING…" : "ADD CREDITS"}</button>
        </DialogContent>
      </Dialog>
    </>
  );
}
